import { AxiosResponse } from 'axios';
import internalApiClient from '~/app/shared/util/api/internalApiClient';
import { BookedEntryDepartment, DimensionData } from '~/types/internal-api';

export function updateBookedEntryDimensionValues(values): Promise<AxiosResponse> {
    const data = values.entryIds.map(
        entryId =>
            ({
                entryId,
                departmentId: undefined,
                dimensionData: values.allDimensions
                    .filter(d => d.dimValKey)
                    .map(
                        d =>
                            ({
                                dimensionId: d.dimId,
                                dimensionKey: d.dimValKey,
                            }) as DimensionData
                    ),
            }) as BookedEntryDepartment
    );
    return internalApiClient.post<undefined, AxiosResponse, BookedEntryDepartment[]>(
        `internal-api/booked-entry/update-department`,
        data
    );
}
